(function() { window.GUID_7271fcf8_0f63_42b2_999c_1b5526df85c8 = { getGuid: function() { return "7271fcf8-0f63-42b2-999c-1b5526df85c8"; } }; })();
var Newsfeed;
(function (Newsfeed) {
    let Filter;
    (function (Filter) {
        Filter[Filter["All"] = 0] = "All";
        Filter[Filter["FromMe"] = 1] = "FromMe";
        Filter[Filter["ToMe"] = 2] = "ToMe";
    })(Filter = Newsfeed.Filter || (Newsfeed.Filter = {}));
    new Newsfeed.NewsfeedPosts();
})(Newsfeed || (Newsfeed = {}));

//# sourceMappingURL=newsfeed.js.map
